import { motion } from "framer-motion";
import { Avatar } from "./Avatar";
import { CARD_ENTER, TAP_SOFT, cardStagger } from "./motionPresets";

export const CharacterGrid = ({ crew, isAvailable, selectedId, onSelect }) => (
  <div className="grid grid-cols-2 gap-2" data-testid="character-grid">
    {crew.characters.map((c, i) => {
      const available = isAvailable(c);
      const selected = selectedId === c.id;
      return (
        <motion.button
          key={c.id}
          type="button"
          data-testid={`character-${c.id}`}
          disabled={!available}
          onClick={() => onSelect(c)}
          {...CARD_ENTER}
          transition={cardStagger(i)}
          whileTap={available ? TAP_SOFT : undefined}
          className={`char-card text-left rounded-[20px] p-2.5 flex items-center gap-2.5 ${
            selected ? "char-selected" : ""
          } ${available ? "" : "opacity-40 cursor-not-allowed"}`}
        >
          <Avatar name={c.name} size={38} />
          <div className="min-w-0">
            <p className="text-[13px] font-bold text-[#14233D] leading-tight line-clamp-2">{c.name}</p>
            <p className="label-mono text-[9px] text-[#7433C1] mt-1 truncate">
              {available ? c.era || "\u00A0" : "Già in ciurma"}
            </p>
          </div>
        </motion.button>
      );
    })}
  </div>
);
